import { defineStore, acceptHMRUpdate } from 'pinia'

interface BookingTypeCardState {
  // Pinia state for the booking type card selection panel.

  selectedBookingTypeId: string | null
  // Id of the currently selected booking type; null when none is selected.
}

export const useBookingTypeCardStore = defineStore('bookingTypeCard', {
  state: (): BookingTypeCardState => ({
    selectedBookingTypeId: null,
  }),
  getters: {
    hasSelection: (state): boolean => state.selectedBookingTypeId !== null,
  },
  actions: {
    selectBookingType(id: string): void {
      if (this.selectedBookingTypeId === id) return
      this.selectedBookingTypeId = id
    },
    clearSelection(): void {
      this.selectedBookingTypeId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBookingTypeCardStore, import.meta.hot))
}
